// src/components/Navbar.jsx
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom"; // Added useLocation hook
import "./Navbar.css";
import { useBrand } from "../brand/BrandContext";
import AccountMenu from "../auth/AccountMenu";

function Navbar({
  logoSrc,
  logoAlt,
}) {
  const { showAccountMenu, ...brand } = useBrand();
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation(); // Get current route
  const toggleSidebar = () => setIsOpen((o) => !o);

  // Brand-aware chrome (props still override, e.g. widget embeds).
  const brandLogo = logoSrc || brand.logoSrc;
  const brandLogoAlt = logoAlt || brand.logoAlt;

  // Check if current path is a district page
  const isDistrictPage = location.pathname.startsWith("/districts/");

  return (
    <div>
      <nav className="navbar">
        <div className="navbar-left">
          {/* Only show hamburger if we are NOT on a district page (since sidebar will be empty) */}
          {!isDistrictPage && (
            <div className="hamburger" onClick={toggleSidebar}>
              &#9776;
            </div>
          )}
          
          <Link to={brand.homePath} className="logo-and-title">
            <img src={brandLogo} alt={brandLogoAlt} />
            <h1>{brand.name}</h1>
          </Link>
        </div>

        <div className="nav-links">
          {/* Only show these 3 links if NOT on a district page */}
          {!isDistrictPage && (
            <>
              <Link to={brand.homePath}>Home</Link>
              <Link to="/about">About</Link>
              <Link to={brand.demoPath}>{brand.demoLabel}</Link>
              <Link to="/patents">Patents</Link>
            </>
          )}
        </div>

        <div className="navbar-right">
          {/* Account menu renders everywhere except district pages whose tenant
              doesn't use accounts at all (dashboard_gate/premium_gate both 'none'). */}
          {showAccountMenu && <AccountMenu />}
          <Link
            to="/contactus"
            className="navbar-cta"
          >
            <span className="navbar-cta-inner">
              <span className="navbar-cta-label">Contact sales</span>
              <span className="navbar-cta-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" width="16" height="16">
                  <path
                    d="M5 12h12M13 6l6 6-6 6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </span>
          </Link>
        </div>
      </nav>

      {/* Mobile Sidebar */}
      <div className={`sidebar ${isOpen ? "open" : ""}`}>
        <div className="close-btn" onClick={toggleSidebar}>
          &times;
        </div>
        
        {/* Only render sidebar links if NOT on a district page */}
        {!isDistrictPage && (
          <>
            <Link to={brand.homePath} onClick={toggleSidebar}>
              Home
            </Link>
            <Link to="/about" onClick={toggleSidebar}>
              About
            </Link>
            <Link to={brand.demoPath} onClick={toggleSidebar}>
              {brand.demoLabel}
            </Link>
            <Link to="/patents" onClick={toggleSidebar}>
              Patents
            </Link>
          </>
        )}
      </div>
    </div>
  );
}

export default Navbar;